import { Loader } from "@googlemaps/js-api-loader";

const API_KEY = "AIzaSyAKtHHwQfH95ojuBuXbzBVuA5Mme359crc";

export function initializeMap(element, markers = {}, mapOptions = {}) {
    const loader = new Loader({
        apiKey: API_KEY,
        version: "weekly",
        libraries: ["places"], // Add any additional libraries you need
    });

    loader.load().then(() => {
        if (mapOptions.latitude && mapOptions.longitude) {
            mapOptions["center"] = new google.maps.LatLng(
                mapOptions.latitude,
                mapOptions.longitude
            );
        }

        // Initialize and render the map
        const map = new google.maps.Map(document.querySelector(element), {
            ...{
                center: new google.maps.LatLng(48.65, 19.65),
                zoom: 7,
                clickableIcons: false,
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false,
                gestureHandling: "cooperative",
            },
            ...mapOptions,
        });

        // Add markers
        if (Object.keys(markers).length !== 0) {
            const bounds = new google.maps.LatLngBounds();

            for (const branch of Object.values(markers)) {
                if (!branch.latitude || !branch.longitude) {
                    continue;
                }

                const markerPosition = {
                    lat: parseFloat(branch.latitude),
                    lng: parseFloat(branch.longitude),
                };
                bounds.extend(markerPosition);
                const markerOptions = {
                    position: markerPosition,
                    map: map,
                    title: branch.name,
                };

                if (branch.icon) {
                    markerOptions["icon"] = {
                        url: branch.icon,
                        scaledSize: new google.maps.Size(35, 47),
                    };
                }

                const marker = new google.maps.Marker(markerOptions);
                const url = new URL(window.location.href);
                const baseUrl =
                    url.origin + url.pathname.substring(0, url.pathname.lastIndexOf("/"));
                const branchDetailLink = `predajna/${branch.id}/${slugify(branch.city + " " + branch.street)}`;

                const content = `
                <div class="sc-info-window">
                    <figure class="sc-info-window__image">
                        <a href="${branchDetailLink}" class="c-link">
                            <img src="${baseUrl + "/images/md/" + branch.image}" alt="${branch.name}" class="c-img" />
                        </a>
                    </figure>

                    <h5 class="sc-info-window__name">
                         <a href="${branchDetailLink}" class="c-link">
                            ${branch.name}
                        </a>
                    </h5>

                    <div class="sc-info-window__adress">
                        <p>${branch.street}, ${branch.post_code} ${branch.city}</p>
                        <p><strong>Po – Pi</strong>${branch.poPi}</p>

                    </div>

                    <div class="sc-info-window__contact">
                        <a target="_blank" href="mailto:${branch.email}" class="c-link">${branch.email}</a>
                        <a target="_blank" href="tel:${branch.phone}" class="c-link">${branch.phone}</a>
                    </div>
                </div>
            `;

                const infoWindow = new google.maps.InfoWindow({
                    content: content,
                });

                marker.addListener("click", () => {
                    infoWindow.open(map, marker);
                    map.setZoom(11);
                    map.setCenter(marker.getPosition());
                });

                map.addListener("click", () => {
                    infoWindow.close();
                });
            }

            // Center and zoom the map so that all markers are visible
            if (!bounds.isEmpty() && !mapOptions.center) {
                const maxZoom = mapOptions.maxZoom || 15;

                map.fitBounds(bounds, 40);

                // fitBounds zooms in too much when there is only one marker
                google.maps.event.addListenerOnce(map, "idle", () => {
                    if (map.getZoom() > maxZoom) {
                        map.setZoom(maxZoom);
                    }
                });
            }
        }
    });

    function slugify(text) {
        return text
            .toString()
            .toLowerCase()
            .trim()
            .replace(/\s+/g, "-")
            .replace(/[^\w\-]+/g, "")
            .replace(/\-\-+/g, "-");
    }
}
